module.exports = __webpack_public_path__ + "static/media/majorD5.8441a44.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD5.wav
// module id = GMjL
// module chunks = 0